import { history } from "../store/index";
import { store } from "../../NextApp";
import { generateQueryString } from "../../util/Api";
import _ from 'underscore';
import {
    CLEAR_ASSET_DATA,
    CLEAR_ASSET_FOR_LABEL_DATA,
    CREATE_ASSET_SUCCESS,
    FETCH_ASSET_CODE_BY_MODEL_ID_SUCCESS,
    FETCH_ASSET_FOR_LABEL_SUCCESS,
    FETCH_ASSET_HISTORY_REPORT_DATA_SUCCESS,
    FETCH_ASSET_REPORT_DATA_SUCCESS,
    FETCH_ASSET_SUCCESS,
    FETCH_BOWSER_DATA_SUCCESS, FETCH_DEVICE_FUEL_END, FETCH_DEVICE_FUEL_START, FETCH_START,
    GET_ALL_ASSET_TYPE_SUCCESS,
    GET_ALL_ASSETS_START,
    GET_ALL_ASSETS_SUCCESS, GET_ASSET_DEVICE_DAILY_FUEL_DATA_SUCCESS, GET_ASSET_DEVICE_FUEL_DATA_SUCCESS,
    GET_ASSET_DEVICE_LAST_DATA_SUCCESS,
    GET_ASSET_DEVICE_RANGE_DATA_SUCCESS,
    GET_ASSET_FROM_CODE_SUCCESS,
    GET_ASSET_FROM_QR_SUCCESS,
    GET_ASSET_IMAGES_SUCCESS,
    GET_ASSET_LAST_IMAGE_SUCCESS,
    GET_ASSET_MODEL_BY_SUBTYPE_SUCCESS,
    GET_ASSET_SUCCESS,
    GET_EQUIPMENT_SUB_TYPE_BY_ASSET_TYPES_SUCCESS,
    GET_IDEAL_ASSET_COUNT_START,
    GET_IDEAL_ASSET_COUNT_SUCCESS,
    GET_MODEL_BY_ASSET_MAKES_SUCCESS, GET_TAGGED_DEVICE_DATA_SUCCESS,
    MAKE_ASSET_LEASABLE,
    SAVE_ASSET_QUERY,
    FETCH_DEVICE_DAILY_FUEL_START,
    FETCH_DEVICE_DAILY_FUEL_END, GET_RECXONCILIATION_ASSETS_SUCCESS, GET_RECONCILIATION_ASSETS_SUCCESS,
    PROCESS_DEVICE_DAILY_FUEL_DATA_IN_PERIOD_SUCCESS
} from "../../constants/ActionTypes";

import axios from "util/Api";
import { downloadProgress, fetchError, fetchStart, fetchSuccess, fetchDataStart, fetchDataSuccess, fetchDataError } from "./Common";
import { message, notification, Typography } from "antd";
import { downloadCSV, sanitizeFieldName } from "../../util/methods";
import * as moment from "moment";
import React from "react";

const { Title } = Typography;

export function arrayToCSV(input, filter, selectedColumns, columns) {
    // console.log(columns);
    var CSV_SEPARATOR = ";";
    var headers = getHeaders(input);
    var lines = getLines(input, headers);

    for (let i in headers) {
        if (headers[i] === "client") {
            headers[i] = "subLocation";
        }
        if (headers[i] === "equipmentSubType") {
            headers[i] = "assetSubType";
        }
        headers[i] = sanitizeFieldName(headers[i]);
    }

    return [headers.join(CSV_SEPARATOR)].concat(lines).join("\n");

    function getRenderForFieldByTypeForCsv(value, type, item = "") {
        // console.log(value, type);
        switch (type) {
            case "Number":
                return value || 0;
            case "String":
                return value || "--";
            case "Date":
                if (item === "createdAt" || item === "updatedAt") {
                    return value
                        ? moment(value || "").format("DD-MM-YYYY hh:mm a")
                        : "--";
                }
                return value ? moment(value || "").format("DD-MM-YYYY") : "--";
            case "ObjectID":
                if (Array.isArray(value)) {
                    return value.map(item => item.name).join(",");
                }

                if (value && value.name) {
                    return value.name;
                }

                if (value && value.assetCode) {
                    return value.assetCode;
                }

                return value || "--";
            case "Array":
                return value && value.map(itm => {
                    if (!itm) return '';
                    if (typeof itm === 'string' || typeof itm === 'number') return itm;
                    if (itm.role) return itm.role;
                    if (itm.name && itm.reading) return `${itm.reading} ${itm.name}`;
                    if (itm.unit) return `${itm.reading} ${itm.unit.name}`;
                    if (itm.name) return `${itm.name}`;
                    return '-';
                }).join('/');
            default:
                return value || "--";
        }
    }

    function getHeaders(input) {
        var headers = new Set();
        columns = JSON.parse(columns);
        columns.map(key => {
            // console.log(key);
            if (key === "assetSubType") {
                headers.add("equipmentSubType");
            }
            if (key === "subLocation") {
                headers.add("client");
            }
            if (key === "assetLinkedParent") {
                headers.add("parent");
            }
            if (key === "purchaseVendor") {
                headers.add("purchaseVendor");
            }
            if (filter[key] && filter[key].type) {
                headers.add(key);
            }
        });
        return Array.from(headers);
    }

    function getLines(input, headers) {
        // console.log(input, headers);
        return input.map(function (obj) {
            return headers
                .map(function (head) {
                    let val = null;
                    if (head !== "assetType") {
                        if (head === 'purchaseVendor') {
                            val = getRenderForFieldByTypeForCsv(
                                obj['vendor'],
                                'ObjectID',
                                head
                            );
                        } else
                            val = getRenderForFieldByTypeForCsv(
                                obj[head],
                                filter[head].type,
                                head
                            );
                    } else {
                        if (head === "assetType") {
                            val = getRenderForFieldByTypeForCsv(
                                obj["equipmentSubType"]["assetType"],
                                "ObjectID"
                            );
                        }
                    }
                    return val || "";
                })
                .join(CSV_SEPARATOR);
        });
    }
}

export const getResourceSuccess = ({ data, count }) => {
    return {
        type: GET_ASSET_SUCCESS,
        data,
        count
    };
};

export const saveResourceQuery = query => {
    return {
        type: SAVE_ASSET_QUERY,
        query
    };
};

export const createResourceSuccess = ({ data }) => {
    return {
        type: CREATE_ASSET_SUCCESS,
        data
    };
};

export const fetchResourceSuccess = ({ data }) => {
    return {
        type: FETCH_ASSET_SUCCESS,
        data
    };
};

export const fetchResourceForLabelSuccess = ({ data }) => {
    return {
        type: FETCH_ASSET_FOR_LABEL_SUCCESS,
        data
    };
};

export const fetchAssetModelBySubTypeSuccess = data => {
    return {
        type: GET_ASSET_MODEL_BY_SUBTYPE_SUCCESS,
        data
    };
};

export const fetchAssetCodeByModelIdSuccess = ({ data }) => {
    return {
        type: FETCH_ASSET_CODE_BY_MODEL_ID_SUCCESS,
        data
    };
};

export const getAllAssetTypeSuccess = ({ data }) => {
    return {
        type: GET_ALL_ASSET_TYPE_SUCCESS,
        data
    };
};

export const getEquipmentSubTypeByAssetTypesSuccess = ({ data }) => {
    return {
        type: GET_EQUIPMENT_SUB_TYPE_BY_ASSET_TYPES_SUCCESS,
        data
    };
};

export const getModelByAssetMakesSuccess = ({ data }) => {
    return {
        type: GET_MODEL_BY_ASSET_MAKES_SUCCESS,
        data
    };
};

export const fetchAssetReportDataSuccess = ({ data }) => {
    return {
        type: FETCH_ASSET_REPORT_DATA_SUCCESS,
        data
    };
};

export const fetchAssetHistoryReportDataSuccess = ({ data }) => {
    return {
        type: FETCH_ASSET_HISTORY_REPORT_DATA_SUCCESS,
        data
    };
};

export const clearData = () => {
    return {
        type: CLEAR_ASSET_DATA
    };
};

/*export const clearAssetModelData = () => {
  return {
    type: CLEAR_ASSET_MODEL_DATA,
  }
}; */

export const clearDataForLabel = () => {
    return {
        type: CLEAR_ASSET_FOR_LABEL_DATA
    };
};

export const getResourceForDownload = (
    columns,
    filters,
    selectedColumns,
    name
) => {
    return async dispatch => {
        dispatch(fetchStart());

        try {
            const { asset } = store.getState();
            const { query } = asset;
            const response = await axios.get(
                `/asset/download?columns=${columns}&${generateQueryString(query)}`,
                {
                    responseType: "stream",
                    onDownloadProgress: function (progressEvent) {
                        dispatch(
                            downloadProgress(
                                progressEvent.total,
                                (progressEvent.loaded / 1024 / 1024).toFixed(2)
                            )
                        );
                    }
                }
            );
            const userData = await axios.get("/auth/user");
            const finalResponse = [];
            // console.log(response.data)
            if (response && response.data && response.data.length > 0) {
                await Promise.all(
                    response.data.map(async record => {
                        const originUrlOfOrg =
                            userData && userData.config && userData.config.baseURL;
                        record["qrCodeUrlData"] = `${window.location.origin
                            }/asset/qr-code?organizationId=${userData &&
                            userData.data &&
                            userData.data.organisation._id}&assetCode=${record.assetCode}`;
                        // finalResponse.push(record);

                        const scannerData = record.scannerData || [];
                        const qrData = scannerData.filter(scanner => scanner.type === 'QR')
                        if (qrData && qrData.length)
                            record["qrLinked"] = qrData[qrData.length - 1] && qrData[qrData.length - 1]['id']; // `https://qrcode.theassetpro.com/api/qr/${qrData[0]['id']}`;
                        // else record["qrLinked"] = 'No';
                        finalResponse.push(record);
                    })
                );
            }
            dispatch(downloadProgress(0, 0));
            dispatch(fetchSuccess());
            columns = JSON.parse(columns);
            if (columns.includes("qrCode")) {
                columns = columns.filter(item => item !== "qrCode");
                columns.push("qrCodeUrlData");
                columns.push("qrLinked");
            }
            columns = JSON.stringify(columns);
            filters.qrCodeUrlData = {
                field: "qrCodeUrlData",
                options: {},
                required: false,
                type: "String"
            };
            filters.qrLinked = {
                field: "qrLinked",
                options: {},
                required: false,
                type: "String"
            };
            filters.saleVendor = {
                field: "saleVendor",
                options: {},
                required: false,
                type: "String"
            };
            // console.log(finalResponse);
            // console.log(filters)
            // console.log(selectedColumns)
            // console.log(columns)

            const str = arrayToCSV(finalResponse, filters, selectedColumns, columns);
            downloadCSV(str, name);
        } catch (error) {
            message.error(error.response.data.message);
            dispatch(fetchError(error.response.data.message));
            console.log("Error****:", error.response.data.message);
        }
    };
};

export const getResourceForQrCodes = () => {
    return async dispatch => {
        dispatch(fetchStart());
        try {
            const { asset } = store.getState();
            const { query } = asset;
            const response = await axios.get(
                `/asset/download?${generateQueryString(query)}`
            );
            dispatch(fetchSuccess());
            let data = response && response.data;
            return data;
        } catch (error) {
            message.error(error.response.data.message);
            dispatch(fetchError(error.response.data.message));
            console.log("Error****:", error.response.data.message);
        }
    };
};

export const getResource = () => {
    return async dispatch => {
        dispatch(fetchDataStart());

        try {
            const { asset } = store.getState();
            const { query } = asset;
            const response = await axios.get(`/asset?${generateQueryString(query)}`);
            if (response && response.data && response.data.length === 0) {
                message.error("Record not found");
            }
            // console.log(response.data)            
            dispatch(getResourceSuccess(response.data));
            dispatch(fetchDataSuccess());
        } catch (error) {
            // message.error(error.response.data.message);
            message.error("Record not found");
            // const dbQuery = {
            //   sort: {
            //     field: "",
            //     order: ""
            //   },
            //   pagination: {
            //     pageSize: 10,
            //     current: 1,
            //     total: 3659
            //   },
            //   filters: {}
            // };
            // dispatch(saveResourceQuery(dbQuery));
            dispatch(fetchDataError(error.response.data.message));
            console.log("Error****:", error.response.data.message);
        }
    };
};

export const findAssetModelBySubType = id => {
    return async dispatch => {
        dispatch(fetchStart());

        try {
            const response = await axios.get(`/asset-model/asset/subtype?id=${id}`);
            dispatch(fetchSuccess());
            dispatch(fetchAssetModelBySubTypeSuccess(response.data));
        } catch (error) {
            dispatch(fetchError(error.response.data.message));
            console.log("Error****:", error.response.data.message);
        }
    };
};

export const getAllAssetType = () => {
    return async dispatch => {
        dispatch(fetchStart());
        try {
            const response = await axios.get(`/asset/get-all-asset-type`);
            dispatch(fetchSuccess());
            dispatch(getAllAssetTypeSuccess(response));
        } catch (error) {
            message.error(error.response.data.message);
            dispatch(fetchError(error.response.data.message));
            console.log("Error****:", error.response.data.message);
        }
    };
};

export const fetchAssetReportData = payload => {
    return async dispatch => {
        dispatch(fetchStart());

        try {
            const response = await axios.post(`/asset/report`, payload);
            dispatch(fetchSuccess());
            dispatch(fetchAssetReportDataSuccess(response));
        } catch (error) {
            message.error(error.response.data.message);
            dispatch(fetchError(error.response.data.message));
            console.log("Error****:", error.response.data.message);
        }
    };
};

export const fetchAssetHistoryReportData = id => {
    return async dispatch => {
        dispatch(fetchStart());

        try {
            const response = await axios.get(`/common/report/${id}`);
            dispatch(fetchSuccess());
            dispatch(fetchAssetHistoryReportDataSuccess(response));
        } catch (error) {
            message.error(error.response.data.message);
            dispatch(fetchError(error.response.data.message));
            console.log("Error****:", error.response.data.message);
        }
    };
};

export const getEquipmentSubTypeByAssetTypes = payload => {
    return async dispatch => {
        dispatch(fetchStart());

        try {
            let data = "";
            if (payload === "All") {
                data = "All";
            } else {
                data = `${JSON.stringify(payload)}`;
            }
            const response = await axios.get(
                `/asset/get-equipment-sub-type-by-asset-types?assetTypes=${data}`
            );
            dispatch(fetchSuccess());
            dispatch(getEquipmentSubTypeByAssetTypesSuccess(response));
        } catch (error) {
            message.error(error.response.data.message);
            dispatch(fetchError(error.response.data.message));
            console.log("Error****:", error.response.data.message);
        }
    };
};

export const getModelByAssetMakes = payload => {
    return async dispatch => {
        dispatch(fetchStart());

        try {
            let data = "";
            if (payload === "All") {
                data = "All";
            } else {
                data = `${JSON.stringify(payload)}`;
            }
            const response = await axios.get(
                `/asset/get-equipment-model-by-asset-makes?assetMakes=${data}`
            );
            dispatch(fetchSuccess());
            dispatch(getModelByAssetMakesSuccess(response));
        } catch (error) {
            message.error(error.response.data.message);
            dispatch(fetchError(error.response.data.message));
            console.log("Error****:", error.response.data.message);
        }
    };
};

export const createResource = payload => {
    return async dispatch => {
        dispatch(fetchStart());

        try {
            let formData = new FormData();

            const documentData = [];
            payload.documents.map((item, index) => {
                formData.append("files", item.file);
                let data = { ...item };
                delete data.file;
                documentData.push(data);
            });

            formData.append("documentData", JSON.stringify(documentData));
            formData.append("readings", JSON.stringify(payload.readings));

            Object.keys(payload).forEach(key => {
                if (key === "documents") {
                    return;
                }
                if (key === "readings") {
                    return;
                }
                if (!payload[key]) {
                    return;
                }

                formData.append(key, payload[key]);
            });

            const response = await axios.post(`/asset`, formData, {
                config: { headers: { "Content-Type": "multipart/form-data" } }
            });
            dispatch(fetchSuccess());
            dispatch(createResourceSuccess({ data: response.data }));
            history.push("/asset");
            dispatch(getResource());
        } catch (error) {
            message.error(error.response.data.message);
            dispatch(fetchError(error));
            console.log("Error****:", error);
        }
    };
};

export const updateResource = (payload, id) => {
    return async dispatch => {
        dispatch(fetchStart());

        try {
            let formData = new FormData();

            const documentData = [];
            const documentIds = [];
            payload.documents &&
                payload.documents.map((item, index) => {
                    if (!item.file.path) {
                        formData.append("files", item.file);
                        let data = { ...item };
                        delete data.file;
                        documentData.push(data);
                    } else {
                        documentIds.push(item._id);
                    }
                });

            formData.append("documentData", JSON.stringify(documentData));
            formData.append("documentIds", JSON.stringify(documentIds));
            if (payload.readings) {
                formData.append("readings", JSON.stringify(payload.readings));
            }

            Object.keys(payload).forEach(key => {
                if (key === "documents") {
                    return;
                }

                if (key === "readings") {
                    return;
                }

                if (!payload[key]) {
                    return;
                }

                formData.append(key, payload[key]);
            });
            const response = await axios.put(`/asset/${id}`, formData, {
                config: { headers: { "Content-Type": "multipart/form-data" } }
            });
            // console.log(response);
            if (response && response.data && response.data.code === 202) {
                message.error(response.data.message);
            } else {
                message.success("Asset updated");
                history.push("/asset");
            }
            dispatch(fetchSuccess());
            dispatch(getResource());
        } catch (error) {
            console.log("Error****:", error);
            message.error(error);
            dispatch(fetchError(error.response.data.message));
        }
    };
};

export const uploadDocuments = (payload, id) => {
    return async dispatch => {
        dispatch(fetchStart());

        try {
            let formData = new FormData();

            const documentData = [];
            const documentIds = [];
            payload.documents &&
                payload.documents.map((item, index) => {
                    if (!item.file.path) {
                        formData.append("files", item.file);
                        let data = { ...item };
                        delete data.file;
                        documentData.push(data);
                    } else {
                        documentIds.push(item._id);
                    }
                });

            formData.append("documentData", JSON.stringify(documentData));
            formData.append("documentIds", JSON.stringify(documentIds));
            if (payload.readings) {
                formData.append("readings", JSON.stringify(payload.readings));
            }

            Object.keys(payload).forEach(key => {
                if (key === "documents") {
                    return;
                }

                if (key === "readings") {
                    return;
                }

                if (!payload[key]) {
                    return;
                }

                formData.append(key, payload[key]);
            });
            var config = {
                headers: {
                    "Content-Type": "multipart/form-data"
                },
                // onUploadProgress: function (progressEvent) {
                //   var percentCompleted = Math.round(
                //     (progressEvent.loaded * 100) / progressEvent.total
                //   );
                //   const key = `upload${id}`;
                //   // console.log(percentCompleted);
                //   notification.open({
                //     key,
                //     placement: "bottomRight",
                //     message: `Uploading Data`,
                //     description: <Progress percent={percentCompleted}/>
                //   });
                //   if(percentCompleted === 100) {
                //     notification.close(key);
                //   }
                // }
            };
            const response = await axios.put(`/asset/upload-docs/${id}`, formData, config);
            dispatch(fetchSuccess());
            // message.info("Document Uploading in background");
            // console.log(response && response.data);
            if (response && response.data && response.data.length) {
                // message.error(response.data.join('<br/>'));
                notification.error({
                    duration: 30,
                    message: `Upload Error from Server!`,
                    description: <>{response.data.map(txt => (<>
                        <Title
                            level={4}>{`${txt.documentName} has been overlapped with ${txt.overlappedDocumentName}`}</Title>
                        <a target='_blank'
                            href={`/document/edit/${txt.overlappedDocumentId}`}>{`Edit ${txt.overlappedDocumentName}`}</a></>))}</>,
                })
            } else {
                history.push("/asset");
            }
            dispatch(getResource());
        } catch (error) {
            console.log("Error****:", error);
            message.error(error);
            dispatch(fetchError(error.response.data.message));
        }
    };
};

export const fetchResource = id => {
    // console.log('Assets - ', id);

    return async dispatch => {
        dispatch(fetchStart());
        try {
            const response = await axios.get(`/asset/${id}`);
            if (
                response &&
                response.data &&
                response.data.equipmentSubType &&
                response.data.equipmentSubType._id
            ) {

                const assetModelData = await axios.get(
                    `/asset-model/asset/subtype?id=${response.data.equipmentSubType._id}`
                );
                if (assetModelData && assetModelData.data) {
                    response.data.assetModelData = assetModelData.data;
                }
            }
            dispatch(fetchSuccess());
            dispatch(fetchResourceSuccess({ data: response.data }));
        } catch (error) {
            console.log("Error****:", error);
            dispatch(fetchError(error.response.data.message));
            console.log("Error****:", error.response.data.message);
        }
    };
};

export const fetchResourceForLabel = id => {
    return async dispatch => {
        dispatch(fetchStart());

        try {
            const response = await axios.get(`/asset/${id}`);
            // console.log(response.data);

            dispatch(fetchSuccess());
            dispatch(fetchResourceForLabelSuccess({ data: response.data }));
        } catch (error) {
            dispatch(fetchError(error.response.data.message));
            console.log("Error****:", error.response.data.message);
        }
    };
};

export const deleteResource = id => {
    return async dispatch => {
        dispatch(fetchStart());

        try {
            await axios.delete(`/asset/${id}`);
            dispatch(fetchSuccess());
            dispatch(getResource());
        } catch (error) {
            dispatch(fetchError(error.response.data.message));
            console.log("Error****:", error.response.data.message);
        }
    };
};

export const fetchAssetCodeByModelId = id => {
    return async dispatch => {
        dispatch(fetchStart());
        // console.log(id);

        try {
            const response = await axios.get(`/asset/getAssetCode?id=${id}`);
            dispatch(fetchSuccess());
            dispatch(fetchAssetCodeByModelIdSuccess({ data: response.data }));
        } catch (error) {
            dispatch(fetchError(error.response.data.message));
            console.log("Error****:", error.response.data.message);
        }
    };
};

export const fetchBowserAssets = (location = '', fuelType = '') => {
    return async dispatch => {
        dispatch(fetchStart());
        try {
            // if (!location || !fuelType) {
            //     dispatch(fetchError("Invalid location or Fuel Type"));
            // } else {
            let url = `/asset/get-all-bowser-assets`;
            if (location && fuelType) {
                url = `/asset/get-bowser-assets/${location}/${fuelType}`;
            }
            // console.log('url =>', url)
            const response = await axios.get(url);
            // console.log('response =>', response.data)
            dispatch(fetchSuccess());
            dispatch(fetchBowserAssetSuccess({ data: response.data }));
            // }
        } catch (error) {
            dispatch(fetchError(error.response.data.message));
            console.log("Error****:", error.response.data.message);
        }
    };
};

export const makeAssetsLeasable = assetFilterData => {
    return async dispatch => {
        dispatch(fetchStart());
        try {
            const response = await axios.post(
                `/asset/makeAssetsLeasable`,
                assetFilterData
            );
            dispatch(fetchSuccess());
            message.success(`${response.data} asset/s set as Leasable successfully.`);
            dispatch(makeAssetsLeasableSuccess({ data: response.data }));
            if (response.data && parseInt(response.data) > 0) {
                dispatch(getResource());
            }
        } catch (error) {
            dispatch(fetchError(error.response.data.message));
            console.log("Error****:", error.response.data.message);
        }
    };
};

export const fetchBowserAssetSuccess = ({ data }) => {
    return {
        type: FETCH_BOWSER_DATA_SUCCESS,
        data
    };
};

export const makeAssetsLeasableSuccess = ({ data }) => {
    return {
        type: MAKE_ASSET_LEASABLE,
        data
    };
};

export const getAllAssets = (payload = {}) => {
    return async dispatch => {
        dispatch(getAllAssetsStart());
        try {
            const response = await axios.post(`/asset/organisation/all`, payload);
            // console.log(response.data);
            processAssets(response.data).then(docs => {
                // console.log(docs);
                dispatch(getAllAssetsOk({ data: response.data, group: docs }));
            });
        } catch (error) {
            dispatch(getAllAssetsOk({ data: [] }));
            dispatch(fetchError(error.response.data.message));
            console.log("Error****:", error.response.data.message);
        }
    };
};

// An asset on an open ATA has no location until it is received; the dashboard chart
// names that group "In transit" instead of the generic "location (n)".
const IN_TRANSIT_GROUP = 'In transit'
function group_by(docs, property = '', subProperty = '') {
    // return new Promise(done => {
    // const data = _.groupBy(docs, (doc) => doc[property] && doc[property][subProperty]);
    const keyOf = (doc) => (property === 'location' && !doc[property] && doc.status === 'INTRANSIT')
        ? IN_TRANSIT_GROUP
        : (doc[property] && doc[property][subProperty] || 'null')
    const groupData = _.mapObject(_.groupBy(docs, keyOf), (val, key) => {
        return {
            name: (key && key !== 'undefined' && key !== 'null') ? `${key} (${val.length})` : property === 'client' ? `No Sublocation (${val.length})` : `${property} (${val.length})`,
            count: (key && key !== 'undefined' && key !== 'null') ? `${val.length}` : property === 'client' ? `${val.length}` : `${val.length}`,
            children: val,
            // value: val.length,
        }
    });
    const arrays = [];
    Object.entries(groupData).forEach(([key, value]) => {
        // console.log(`${key}: ${value}`);
        arrays.push(value);
    });
    return arrays;
    // })

    // return _.mapObject(groupData, (val, key) => {
    //   console.log(val);
    //   return val;
    // });
}

function processAssets(data) {
    return new Promise(ok => {
        const loc = group_by(data, 'location', 'name');
        // console.log(loc);
        loc.forEach(l => {
            l.children = group_by(l.children, 'client', 'name');
            l.children.forEach(c => {
                c.children = group_by(c.children, 'assetType', 'name');
                c.children.forEach(eq => {
                    eq.children = group_by(eq.children, 'equipmentSubType', 'name');
                    eq.children.forEach(md => {
                        md.children = group_by(md.children, 'assetModel', 'name');
                        md.children.forEach(as => {
                            as.value = as.children.length;
                            delete as.children;
                        })
                    })
                })
            })
        });
        ok({
            "name": "Assets",
            "count": data.length,
            "children": loc
        });

        // _.mapObject(_.groupBy(data, (doc) => doc.location && doc.location.name), (val, key) => {
        //   return {
        //     name: key,
        //     children: _.mapObject(_.groupBy(val, (doc) => doc.client ? doc.client.name : 'NoSubLocation'), (val, key) => {
        //       return {
        //         name: key,
        //         children: _.mapObject(_.groupBy(val, (doc) => doc.equipmentSubType && doc.equipmentSubType.name), (val, key) => {
        //           return {
        //             name: key,
        //             children: _.mapObject(_.groupBy(val, (doc) => doc.equipmentSubType && doc.equipmentSubType.assetType && doc.equipmentSubType.assetType.name), (val, key) => {
        //               return {
        //                 name: key,
        //                 children: _.mapObject(_.groupBy(val, (doc) => doc.assetModel && doc.assetModel.name), (val, key) => {
        //                   return {name: key, children: val}
        //                 })
        //               };
        //             })
        //           };
        //         })
        //       }
        //     })
        //   };
        // });
    })
}

export const getAllAssetsOk = ({ data, group }) => {
    return {
        type: GET_ALL_ASSETS_SUCCESS,
        data,
        group
    };
};

export const getAllAssetsStart = () => {
    return {
        type: GET_ALL_ASSETS_START
    };
};


export const getIdealAssetCount = (payload = {}) => {
    return async dispatch => {
        dispatch(getIdealAssetCountStart());
        try {
            const response = await axios.post(`/asset/get-ideal-asset-count`, payload);
            // console.log(response);
            dispatch(getIdealAssetCountOk(response.data[0]));
        } catch (error) {
            dispatch(getIdealAssetCountOk({ count: 0 }));
            dispatch(fetchError(error));
            console.log("Error****:", error);
        }
    };
};

export const getIdealAssetCountOk = ({ count }) => {
    return {
        type: GET_IDEAL_ASSET_COUNT_SUCCESS,
        count
    };
};

export const getIdealAssetCountStart = () => {
    return {
        type: GET_IDEAL_ASSET_COUNT_START
    };
};

export const getAssetByQr = (qrId) => {
    return async dispatch => {
        dispatch(fetchStart());
        try {
            const response = await axios.get(`/asset/qr-to-asset/${qrId}`);
            // console.log(response);
            dispatch(fetchSuccess());
            dispatch(getAssetFromQrSuccess({ qrId, data: response.data, time: new Date().getTime() }));
        } catch (error) {
            dispatch(fetchError(error));
            console.log("Error****:", error);
        }
    };
};

export const getAssetFromQrSuccess = (data) => {
    return {
        type: GET_ASSET_FROM_QR_SUCCESS,
        data
    };
};

export const getAssetByCode = (assetCode) => {
    return async dispatch => {
        dispatch(fetchStart());
        try {
            const response = await axios.get(`/asset/get-asset-by-code/${assetCode}`);
            // console.log(response);
            dispatch(fetchSuccess());
            dispatch(getAssetFromCodeSuccess({ assetCode, data: response.data, time: new Date().getTime() }));
        } catch (error) {
            dispatch(fetchError(error));
            console.log("Error****:", error);
        }
    };
};

export const getAssetFromCodeSuccess = (data) => {
    return {
        type: GET_ASSET_FROM_CODE_SUCCESS,
        data
    };
};

export const getAssetByCodeSl = (assetCode) => {
    return async dispatch => {
        dispatch(fetchStart());
        try {
            const response = await axios.get(`/asset/get-asset-by-code-sl/${assetCode}`);
            // console.log(response);
            dispatch(fetchSuccess());
            dispatch(getAssetFromCodeSuccess({ assetCode, data: response.data, time: new Date().getTime() }));
        } catch (error) {
            dispatch(fetchError(error));
            console.log("Error****:", error);
        }
    };
};

export const getAssetLastImage = (assetId) => {
    return async dispatch => {
        dispatch(fetchStart());
        try {
            const response = await axios.get(`/common/asset-last-image/${assetId}`);
            dispatch(fetchSuccess());
            dispatch(getAssetLastImageSuccess({ asset: assetId, images: response.data && response.data.images }));
        } catch (error) {
            dispatch(fetchError(error));
            console.log("Error****:", error);
        }
    };
};

export const getAssetLastImageSuccess = (data) => {
    return {
        type: GET_ASSET_LAST_IMAGE_SUCCESS,
        data
    };
};

export const getAssetImages = (assetId) => {
    return async dispatch => {
        dispatch(fetchStart());
        try {
            const response = await axios.get(`/common/asset-image/${assetId}`);
            // console.log(response);
            dispatch(fetchSuccess());
            dispatch(getAssetImageSuccess({ asset: assetId, images: response.data && response.data.images }));
        } catch (error) {
            dispatch(fetchError(error));
            console.log("Error****:", error);
        }
    };
};

export const getAssetImageSuccess = (data) => {
    return {
        type: GET_ASSET_IMAGES_SUCCESS,
        data
    };
};

export const getAssetDeviceLastData = (assetId, device) => {
    // console.log('lassss', assetId, device)
    return async dispatch => {
        dispatch(fetchStart());
        try {
            // console.log('last data...')
            const response = await axios.get(`/iot-device-data/${device}/${assetId}`);
            // console.log(response);
            dispatch(fetchSuccess());
            dispatch(getAssetDeviceLastDataSuccess({ asset: assetId, device: device, data: response.data }));
            // Returned so the caller can tell "no record" (null / empty) apart from a failed request (undefined)
            return response.data;
        } catch (error) {
            dispatch(fetchError(error));
            console.log("Error****:", error);
            return undefined;
        }
    };
};

// No longer used: getAssetDeviceLastData's API (backend getLastDeviceData) now falls back to the
// last packet stored in daily fuel data itself when the live table has no record, so this separate
// backup call is not needed. Kept for reference.
//
// // Backup for getAssetDeviceLastData: last packet stored in daily fuel data.
// // Call only on first page load when the live table has no record (never from the SSE live feed).
// export const getAssetDeviceBackupLastData = (assetId, device) => {
//     return async dispatch => {
//         try {
//             const response = await axios.get(`/iot-device-data/backup-last/${device}/${assetId}`);
//             if (response && response.data && Object.keys(response.data).length) {
//                 dispatch(getAssetDeviceLastDataSuccess({ asset: assetId, device: device, data: response.data }));
//             }
//             return response && response.data;
//         } catch (error) {
//             console.log("Error****:", error);
//             return undefined;
//         }
//     };
// };

// Bulk last packet for the Dashboard Device-Map tab (max 50 items per call).
// Plain promise, not a Redux thunk: Device-Map keeps the result in its own state.
// items: [{ device, asset }] -> resolves { data: { '<device>-<asset>': packet | null }, errors, meta }
export const fetchAssetDeviceLastDataBulk = async (items) => {
    const response = await axios.post('/iot-device-data/last-data/bulk', { items });
    return response.data;
};

export const getAssetDeviceLastDataSuccess = (data) => {
    return {
        type: GET_ASSET_DEVICE_LAST_DATA_SUCCESS,
        data
    };
};

export const fetchFuelStart = () => {
    return {
        type: FETCH_DEVICE_FUEL_START
    }
}; export const fetchFuelEnd = () => {
    return {
        type: FETCH_DEVICE_FUEL_END
    }
};

export const getAssetDeviceLastFuelData = (assetId, device) => {
    // console.log('lassssF', assetId, device)
    return async dispatch => {
        dispatch(fetchFuelStart());
        try {
            // console.log('last data...')
            const response = await axios.get(`/iot-device-data/fuel/${device}/${assetId}`);
            // console.log(response);
            dispatch(fetchFuelEnd());
            dispatch(getAssetDeviceFuelDataSuccess({ asset: assetId, device: device, data: response.data }));
        } catch (error) {
            dispatch(fetchFuelEnd());
            console.log("Error****:", error);
        }
    };
};

export const getAssetDeviceFuelDataSuccess = (data) => {
    return {
        type: GET_ASSET_DEVICE_FUEL_DATA_SUCCESS,
        data
    };
};

export const getAssetDeviceRangeData = (assetId, device, from, to) => {
    // console.log('lassssR', assetId, device, from, to)
    return async dispatch => {
        dispatch(fetchStart());
        try {
            const response = await axios.get(`/iot-device-data/in-period/${device}/${from}/${to}/${assetId}`);
            // console.log(response);
            const { data } = response;
            // console.log(data.map(d => d.timestamp))
            dispatch(fetchSuccess());
            dispatch(getAssetDeviceRangeDataSuccess({ asset: assetId, device, data: data && data.deviceData || [], processedData: data && data.deviceProcessedData || {} }));
        } catch (error) {
            console.log("Error****:", error);
            dispatch(fetchError(error));
        }
    };
};

export const getAssetDeviceRangeDataSuccess = (data) => {
    return {
        type: GET_ASSET_DEVICE_RANGE_DATA_SUCCESS,
        data
    };
};

export const getTaggedDeviceAssets = (assetIds) => {
    // console.log('assetIds=>', assetIds);
    return async dispatch => {
        dispatch(fetchStart());
        try {
            const response = await axios.post(`/asset/get-taggable-assets`, { assetIds });
            dispatch(fetchSuccess());
            // console.log('response=>', response.data);
            dispatch(getTaggedDeviceAssetsSuccess(response.data));
        } catch (error) {
            dispatch(fetchError(error));
            console.log("Error****:", error);
        }
    };
};

export const getTaggedDeviceAssetsSuccess = (data) => {
    return {
        type: GET_TAGGED_DEVICE_DATA_SUCCESS,
        data
    };
};

export const start = () => {
    return {
        type: FETCH_DEVICE_DAILY_FUEL_START,
    };
};

export const end = () => {
    return {
        type: FETCH_DEVICE_DAILY_FUEL_END,
    };
};

export const getAssetDeviceDailyFuelData = (assetId, device, from, to, hasFuelSensorAttached = false) => {
    // console.log('lassssD', assetId, device, from, to)

    // console.log('hasFuelSensorAttached=>', hasFuelSensorAttached);
    return async dispatch => {
        dispatch(start());
        dispatch(fetchStart())
        try {
            const response = await axios.get(`/iot-device-data/daily-fuel-consume/${device}/${from}/${to}/${assetId}`);
            // const {data} =response;
            // console.log(data.map(d => d.timestamp))
            dispatch(fetchSuccess());
            const processedData = processDailyFuelData(response, hasFuelSensorAttached);
            // console.log('processedData=>', processedData);
            dispatch(getAssetDeviceDailyFuelDataSuccess({ asset: assetId, device, data: processedData }));
            dispatch(end());
        } catch (error) {
            console.log("Error****:", error);
            dispatch(fetchError(error));
            dispatch(end());
        }
    };
};

export const processDailyFuelData = ({ data }, hasFuelSensorAttached) => {
    // console.log('hasFuelSensorAttached=>>', hasFuelSensorAttached);
    if (data && data.length) {
        // console.log('Data:', data)
        return data.map(doc => {
            const { asset, end_meter, created_at, start_meter, device_id, distance_travelled_fuel_based,
                start_meter_fuel_based, moving_time, distance_travelled, date, end_meter_fuel_based,
                fuel_consumed, fuel_consumed_analog, ideal_time, date_timestamp, timezone, total_refuel,
                total_theft, ignition_time, dataFromTimestamp, dataToTimestamp, manualFuelData,
                start_fuel_level_liters, end_fuel_level_liters, _id
            } = doc;

            const { quantity, isFullTank } = manualFuelData || { quantity: 0, isFullTank: false };

            const meter_distance = distance_travelled && Number(distance_travelled) || 0;
            const effective_distance = meter_distance; //distance_travelled_fuel_based && Number(distance_travelled_fuel_based) || meter_distance;

            // if fuel sensor is attached, use fuel_consumed_analog else use fuel_consumed
            const fuel = hasFuelSensorAttached ? Math.abs(Number(fuel_consumed)) : fuel_consumed && Number(fuel_consumed) && (Number(fuel_consumed) / 10) || 0;
            let rate = fuel ? ((meter_distance / 1000) / fuel) : 0;

            const manual_based_fuel_consumed = fuel - total_refuel + quantity;
            let rate_manual_refuel = manual_based_fuel_consumed ? ((meter_distance / 1000) / manual_based_fuel_consumed) : 0;

            // if (Math.abs(meter_distance - effective_distance) > 1000)
            //     rate = fuel ? ((effective_distance / 1000) / fuel) : 0;

            // let eff_start_meter = start_meter_fuel_based;
            // let eff_end_meter = end_meter_fuel_based;
            // if (!eff_start_meter || !eff_end_meter) {
            //     eff_start_meter = start_meter;
            //     eff_end_meter = end_meter;
            // }
            const rate_ignition_hours = fuel ? ((ignition_time / (60 * 60 * 1000)) / fuel) : 0;
            const rate_manual_refuel_hours = manual_based_fuel_consumed ? ((ignition_time / (60 * 60 * 1000)) / manual_based_fuel_consumed) : 0;

            return {
                ...doc,
                asset,
                daily_fuel_data_id: _id,
                date,
                date_timestamp,
                timezone,
                created_at,
                start_meter: start_meter && Number(start_meter) && Number((Number(start_meter) / 1000)),
                end_meter: end_meter && Number(end_meter) && Number((Number(end_meter) / 1000)),
                distance_travelled: Number(meter_distance / 1000),
                start_meter_effective: start_meter && Number(start_meter) && Number((Number(start_meter) / 1000)),
                end_meter_effective: end_meter && Number(end_meter) && Number((Number(end_meter) / 1000)),
                distance_travelled_effective: Number(effective_distance / 1000),
                fuel_consumed: fuel,
                fuel_consumed_analog: Number(fuel_consumed_analog),
                consumption_rate: Number(rate),
                consumption_rate_ignition: Number(rate_ignition_hours),
                moving_time_ms: moving_time,
                idle_time_ms: ideal_time,
                ignition_time_ms: ignition_time,
                moving_time_min: moving_time ? Number((moving_time / 60000)) : moving_time,
                idle_time_min: ideal_time ? Number((ideal_time / 60000)) : ideal_time,
                ignition_time_min: ignition_time ? Number((ignition_time / 60000)) : ignition_time,
                device_id,
                total_refuel: total_refuel && Number(total_refuel) || 0,
                total_theft: total_theft && Number(total_theft) || 0,
                dataFromTimestamp,
                dataToTimestamp,
                manualRefualQuantity: quantity,
                manualRefualIsFullTank: isFullTank,
                manual_based_fuel_consumed: Number(manual_based_fuel_consumed),
                consumption_rate_manual_refuel: Number(rate_manual_refuel),
                consumption_rate_manual_refuel_hours: Number(rate_manual_refuel_hours),
                start_fuel_level_liters: start_fuel_level_liters && Number(start_fuel_level_liters) || 0,
                end_fuel_level_liters: end_fuel_level_liters && Number(end_fuel_level_liters) || 0
            }
        })
    } else
        return []
}

export const getAssetDeviceDailyFuelDataSuccess = (data) => {
    return {
        type: GET_ASSET_DEVICE_DAILY_FUEL_DATA_SUCCESS,
        data
    };
};

export const getAssetsForReconciliation = () => {
    return async dispatch => {
        dispatch(fetchStart());
        try {
            const response = await axios.get(`/asset/get-assets-for-reconciliation`);
            dispatch(fetchSuccess());
            dispatch(getReconciliationAssetSuccess(response.data));
        } catch (error) {
            dispatch(fetchError(error));
            console.log("Error****:", error);
        }
    };
};

export const getReconciliationAssetSuccess = (data) => {
    return {
        type: GET_RECONCILIATION_ASSETS_SUCCESS,
        data
    };
};

export const processDeviceDailyFuelDataInPeriod = (device, from, to, assetId) => {
    return async dispatch => {
        dispatch(fetchStart());
        try {
            dispatch(processDeviceDailyFuelDataInPeriodSuccess(true));
            const response = await axios.get(`/daily-fuel-data/process-in-period/${device}/from/${from}/to/${to}/${assetId}`);
            const { data } = response;
            dispatch(fetchSuccess());
            dispatch(processDeviceDailyFuelDataInPeriodSuccess(false));
            notification.success({
                message: 'Data Re-Processed started!',
                description: data && data.message || 'Your request has been added, you will receive an email when it is done.',
            });
        } catch (error) {
            dispatch(fetchError(error));
            console.log("Error****:", error);
        }
    }
}

export const processDeviceDailyFuelDataInPeriodSuccess = (data) => {
    return {
        type: PROCESS_DEVICE_DAILY_FUEL_DATA_IN_PERIOD_SUCCESS,
        data
    };
};